import { render, staticRenderFns } from "./Schoolmanagement.vue?vue&type=template&id=49f6ebe6&"
import script from "./Schoolmanagement.vue?vue&type=script&lang=js&"
export * from "./Schoolmanagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports